/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetUserDto } from './GetUserDto';
import {
    GetUserDtoFromJSON,
    GetUserDtoFromJSONTyped,
    GetUserDtoToJSON,
} from './GetUserDto';

/**
 * 
 * @export
 * @interface GetDutyDto
 */
export interface GetDutyDto {
    /**
     * 
     * @type {string}
     * @memberof GetDutyDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetDutyDto
     */
    name?: string | null;
    /**
     * 
     * @type {GetUserDto}
     * @memberof GetDutyDto
     */
    psychologist?: GetUserDto | null;
    /**
     * 
     * @type {GetUserDto}
     * @memberof GetDutyDto
     */
    doctor?: GetUserDto | null;
}

/**
 * Check if a given object implements the GetDutyDto interface.
 */
export function instanceOfGetDutyDto(value: object): value is GetDutyDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetDutyDtoFromJSON(json: any): GetDutyDto {
    return GetDutyDtoFromJSONTyped(json, false);
}

export function GetDutyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDutyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'psychologist': json['psychologist'] == null ? undefined : GetUserDtoFromJSON(json['psychologist']),
        'doctor': json['doctor'] == null ? undefined : GetUserDtoFromJSON(json['doctor']),
    };
}

export function GetDutyDtoToJSON(value?: GetDutyDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'psychologist': GetUserDtoToJSON(value['psychologist']),
        'doctor': GetUserDtoToJSON(value['doctor']),
    };
}

